<app-modal title="Fases" [form]="form" (save)="onSave($event)">
  <form [formGroup]="form">
    <div class="tds-row">
      <app-input
        label="Nome*"
        formControlName="nome"
        maxLength="20"
      ></app-input>
      <app-input label="Sequência*" formControlName="sequencia"></app-input>
    </div>
  </form>
</app-modal>
